import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Cookie from 'js-cookie';
import { parseCookies } from 'nookies';
import { CheckoutGiftWrapper, CheckoutPageContainer } from '../containers';
import { onCheckoutGiftPageOpen, onSuccessRedirect } from "../redux/actions";
import { CHECKOUT_PAYMENT_SET_FETCH } from "../redux/types";

const mapDispatchToProps = dispatch => bindActionCreators({
  onCheckoutProceed: onCheckoutGiftPageOpen,
  onSuccessfulRedirect: onSuccessRedirect,
}, dispatch);

@connect(null, mapDispatchToProps)
class CheckoutGiftPage extends Component {
  static propTypes = {
    onCheckoutProceed: PropTypes.func,
    onSuccessfulRedirect: PropTypes.func,
  };

  static async getInitialProps(ctx) {
    const { reduxStore, req } = ctx;

    if (req && parseCookies(ctx).status) {
      reduxStore.dispatch({ type: CHECKOUT_PAYMENT_SET_FETCH });
    }
  }

  componentDidMount() {
    const { onCheckoutProceed, onSuccessfulRedirect } = this.props;

    if (Cookie.get('status')) {
      onSuccessfulRedirect();
    }

    onCheckoutProceed();
  }

  render() {
    return (
      <CheckoutPageContainer heading="Gift Card">
        <CheckoutGiftWrapper />
      </CheckoutPageContainer>
    );
  }
}

export default CheckoutGiftPage;
